var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.content.length
    ? _c(
        "div",
        { class: _vm.containerClasses },
        [
          _vm.isPageContentArea
            ? [
                _c("div", { staticClass: "visual_menu--page_content" }, [
                  _c("div", {
                    staticClass: "visual_menu--section",
                    domProps: { innerHTML: _vm._s(_vm.content) },
                  }),
                ]),
              ]
            : [_c("div", { domProps: { innerHTML: _vm._s(_vm.content) } })],
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }